import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild,CanLoad, ActivatedRouteSnapshot, RouterStateSnapshot, Route } from '@angular/router';
import { Observable,Subject } from 'rxjs';
import { AuthService } from '../authentication/auth.service';
import { CommunicationService } from '../layout/shared/communication.service';

@Injectable()
export class AuthGuardService implements CanActivate, CanActivateChild, CanLoad {

    constructor(private authService: AuthService,private communicationService: CommunicationService) { }

    //   canActivate(): boolean {
    //       
    //       if(this.authService.isLoggedIn()) {
    //           return true;
    //       }
    //       this.authService.startAuthentication();
    //       return false;
    //   }
    //   canActivateChild(): boolean {
    //     
    //       return this.canActivate();
    //   }
    //   canLoad():boolean{
    //     return this.canActivate();
    //   }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

        if (this.authService.isLoggedIn()) {

            if (+this.authService.getItem("LoginId") > 0)
                return true;
            else {
                var isProfileReceived = new Subject<boolean>();
                this.communicationService.Profile$
                    .subscribe(s => { isProfileReceived.next(s); console.log('authGuard:isProfile Loaded ' + s); });
                return isProfileReceived.asObservable();
            }

        }
        else {
            this.authService.startAuthentication();
            return false;
        }
    }
    canActivateChild(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

        if (this.authService.isLoggedIn())
            return true;
        this.authService.startAuthentication();
        return false;
    }
    canLoad(next: Route): Observable<boolean> | Promise<boolean> | boolean {

        if (this.authService.isLoggedIn())
            return true;
        this.authService.startAuthentication();
        return false;
    }
}
